// localStorage can throw (private mode, blocked storage); UI state must survive that.
export function readFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function writeFlag(key: string, value: boolean) {
  try {
    localStorage.setItem(key, value ? "1" : "0");
  } catch {
    // Not persisted; the in-memory state still applies.
  }
}
